import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const ArrowLeftIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 18",
    fill: "currentColor",
    width: size || '13',
    height: size || '18'
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Actions_05",
    stroke: "none",
    fill: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-180 6.785 9.017)",
    d: "M2.56943454 -4.26325641e-14L1 1.59637082 9.90393128 9.01743437 1.16642458 16.5458666 2.56943454 18.0348687 12.5694345 8.9835939z",
    fill: "currentColor"
  })));
};
ArrowLeftIcon.displayName = 'ArrowLeftIcon';
export default ArrowLeftIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ArrowLeftIcon.js.map